import { useState } from 'react';

const useOpen = init => {
  const [state, setState] = useState(init);

  return {
    opened: state,
    switch: () => setState(!state),
    open: name => setState(name || true),
    close: name => setState(name || false),
  };
};

export default useOpen;
